import { z } from 'zod';
import { floatingPointPrecisionSchema } from './floating-point-precision-schema.ts';
import { SUPPORTED_UNITS_SCHEMA } from '../quote-unit/unit-types.ts';

const PositionQuoteRequestSchemaV2 = z.object({
    positionProductId: z.string().uuid(),
    quota: floatingPointPrecisionSchema,
    unit: SUPPORTED_UNITS_SCHEMA,
    partnerOrganizationId: z.number().positive(),
    projectOwnerOrganizationId: z.number().positive(),
    platformOrganizationId: z.number().positive(),
    purchasePrice: z.number(),
    purchaseTaxClassId: z.string(),
    salesPrice: z.number(),
    salesTaxClassId: z.string(),
    currencyCode: z.string().max(3),
    updatedAt: z.coerce.date(),
    createdAt: z.coerce.date(),
    quoteData: z.any(),
});

export const PostPositionQuoteRequestSchemaV2 = PositionQuoteRequestSchemaV2;
